export const selectWithSearch = {
  placeholder: 'Seleccionar opción...',
  searchPlaceholder: 'Buscar...',
  emptyMessage: 'No se encontraron opciones.',
  moreItems: 'más',
  selectedCount: 'seleccionados',
} as const
